import { apiCMSWithToken } from './axios'

export const url = {
    imess : `/imess`
  }

export async function imessSearch(filters = {}) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(
      `${url.imess }?${params}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function imessAdd(body) {
  const response = await apiCMSWithToken.post(
    `${url.imess}`,
    body
  )
  return response
}
export async function imessUpdate(body, id) {
  const response = await apiCMSWithToken.put(
    `${url.imess}/${id}`,
    body
  )
  return response
}

export async function imessDetail(id) {
  try {
    const response = await apiCMSWithToken.get(
      `${url.imess}/${id}`
    )

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function imessExcel(body) {
  const response = await apiCMSWithToken.post(
    `${url.imess}/import/excel`,
    body,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  return response
}

export async function imessDelete(body) {
  const response = await apiCMSWithToken.put(
    `${url.imess}/todos/delete-selected`,
    {
      ...body
    }
  )
  return response
}


export default {
    imessSearch,
    imessAdd,
    imessUpdate,
    imessDetail,
    imessDelete
  }
  